// https://tigertech.feishu.cn/wiki/wikcnxavLbf4xXUBHZahND8Ogyg?source_type=message&from=message
export const HOST = ['https://test-deposit.ihuhoo.com', 'https://deposit.tradeup.com'];

export const API = {
    // 查询推荐入金方式
    depositWay: '/api/v1/personal/recommend_deposit/choice',
    // 获取可选币种与入金来源 https://tigertech.feishu.cn/wiki/wikcnnET22SIkUTEDOZkOLjyQFd
    getChoiceList: '/api/v1/personal/deposit/choice_v2',
    // 获取收款账号信息与银行列表 https://tigertech.feishu.cn/wiki/wikcn3zBMPhKj8DdzgoNVh9VTad
    getAccountAndBankInfo: '/api/v2/personal/deposit/bankinfo/:id'
};

export function bindCG() {
    const cfg = CG_API['deposit-guide']?.TBUS;

    if (cfg) {
        HOST.fill(cfg);
    }
}
